module.exports = __webpack_public_path__ + "static/media/sa.45e17088.svg";